import React, { useState } from 'react';
import { Table, TableBody, Box } from '@mui/material';
import {
  AccountStatusKeys,
  UserAccountsTableData,
  ACTIVE_SUB_ROWS,
  ACTIVE_SUB_ROWS_HEADER,
} from '../../../data/report/helpers/userAccountsUtils';
import AccountStatusRow from './AccountStatusRow';

interface CondensedTableViewProps {
  rows: AccountStatusKeys[];
  columns: string[];
  data: UserAccountsTableData;
}

const CondensedTableView: React.FC<CondensedTableViewProps> = ({ rows, columns, data }) => {
  const [expandedRow, setExpandedRow] = useState<string | null>(null);

  const toggleExpand = (rowKey: string) => {
    setExpandedRow(prev => (prev === rowKey ? null : rowKey));
  };

  return (
    <Table>
      <TableBody>
        <Box
          sx={{
            borderRadius: '8px',
            overflow: 'hidden',
          }}>
          {rows.map((rowKey, rowIndex) => {
            const isExpanded = expandedRow === rowKey;
            const isLastRow = rowIndex === rows.length - 1;

            return (
              <Box key={rowKey}>
                <AccountStatusRow
                  rowKey={rowKey}
                  columns={columns}
                  data={data}
                  variant='condensed'
                  subRows={rowKey === 'activeUserCount' ? ACTIVE_SUB_ROWS : undefined}
                  subRowHeader={rowKey === 'activeUserCount' ? ACTIVE_SUB_ROWS_HEADER : undefined}
                  isExpanded={isExpanded}
                  onToggleExpand={() => toggleExpand(rowKey)}
                  showDivider={!isLastRow}
                />
              </Box>
            );
          })}
        </Box>
      </TableBody>
    </Table>
  );
};

export default CondensedTableView;
